import styles from './Sidebar.module.css';
import Checkbox from '../../compoenets/Checkbox';
import ListSkeleton from '../../compoenets/ListSkeleton/ListSkeleton';

const List=({isLoad,items,title,name,idName,checkedItems,setCheckedItems})=>{
    const isAllChecked=checkedItems.length===items.length;

    const handleCheckChange=(itemId)=>{
        setCheckedItems(prev=>
            prev.includes(itemId)?
            prev.filter(id=>id!==itemId)
            :[...prev,itemId]
        )
    }

    const handleCheckAll=()=>{
        if(checkedItems.length===items.length){
            setCheckedItems([]);
        }else{
            setCheckedItems(items.map(item=>item[idName]));
        }
    }

    return(
        <section>
            <header>
                <span>{title}</span>
                <button onClick={handleCheckAll}>{isAllChecked?'Uncheck All':'Check All'}</button>
            </header>
            <div className={styles['list-body']}>
                {!isLoad?
                items.map((item)=>
                    <div className={styles['item']} onClick={()=>handleCheckChange(item[idName])}>
                        <Checkbox 
                        isChecked={checkedItems.includes(item[idName])}
                        onChange={()=>handleCheckChange(item[idName])}
                        />
                        <span>{item[name]}</span>
                    </div>
                )
                :
                <>
                    <ListSkeleton/>
                    <ListSkeleton/>
                    <ListSkeleton/>
                    <ListSkeleton/>
                    <ListSkeleton/>
                </>
            }
            </div>
        </section>
    )
}

export default function Sidebar({
    isLoad,
    className,
    modelList,
    testSetList,
    checkedModels,
    setCheckedModels,
    checkedTests,
    setCheckedTests
}){
    return(
        <nav className={`${className} ${styles['wrap']}`}>
            <List
            isLoad={isLoad}
            title='Model List'
            items={modelList}
            idName='modelId'
            name='displayName'
            checkedItems={checkedModels}
            setCheckedItems={setCheckedModels}
            />
            <List
            isLoad={isLoad}
            title='Test Set'
            items={testSetList}
            idName='datasetId'
            name='datasetName'
            checkedItems={checkedTests}
            setCheckedItems={setCheckedTests}
            />
        </nav>
    )
}